import * as React from "react";
import {ProcessSpinner} from "../../../common/processSpinner/ProcessSpinner";
import styles from './PlaylistSkeleton.module.scss';

const SkeletonTrack: React.FC = () => (
    <div className={styles.playlistSkeleton__track}>
        <div className={styles.playlistSkeleton__trackIndex} />
        <div className={styles.playlistSkeleton__trackInfo}>
            <div className={styles.playlistSkeleton__trackTitle} />
            <div className={styles.playlistSkeleton__trackArtist} />
        </div>
    </div>
);

export const PlaylistSkeleton: React.FC = () => (
    <div>
        <div className={styles.playlistSkeleton__header}>
            <div className={styles.playlistSkeleton__img}>
                <ProcessSpinner showText />
            </div>
            <div className={styles.playlistSkeleton__text}>
                <div className={styles.playlistSkeleton__title} />
                <div className={styles.playlistSkeleton__description} />
            </div>
        </div>
        <div className={styles.playlistSkeleton__tracks}>
            {Array.from({length: 12}, (_, i) => <SkeletonTrack key={i} />)}
        </div>
    </div>
);
